import { omit } from '@/shared/utils/omit';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { QuestionType } from '../../sj-orm/models/form/question.dto';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type SocialSecurityGeneralFormType = PersonalIdentifierGeneralFormType;

export const SocialSecurityGeneralSection: SocialSecurityGeneralFormType = {
  ...commonGeneralFields,
};

export type SocialSecurityDetailsDto = Omit<
  PersonalIdentifierDetails,
  'createdAt' | 'updatedAt'
> & {
  idOfficialName?: string;
};

type SocialSecurityDetailsHelp = {
  idOfficialName: QuestionType.TEXT;
};

type SocialSecurityDetailsFormType = Omit<
  PersonalIdentifierDetailsFormType,
  'gender' | 'issuerCode' | 'basisForIssuingId' | 'otherData'
> &
  TDtoWrapper<SocialSecurityDetailsDto, SocialSecurityDetailsHelp>;

export const SocialSecurityDetailsSection: SocialSecurityDetailsFormType = {
  idOfficialName: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:citizenshipCertificate.inputs.idOfficialName.label',
    value: '',
    capitalized: true,
    order: 2,
  },
  ...omit(commonDetailsFields, 'gender', 'issuerCode', 'basisForIssuingId', 'other'),
};

export const SocialSecurityLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const SocialSecurityFormSections = [
  SocialSecurityGeneralSection,
  SocialSecurityDetailsSection,
  SocialSecurityLegalizedCopiesSection,
];
